/* eslint-disable no-undef */
/** @format */

import { forEach, isString } from "lodash";

let pathname = window.document.location.pathname;
let baseConfig = {
  //应用名称
  appName: 'appName',
  //是否开启多时区功能，不开启的话， 多时区功能将会失效
  isTimeZone: true,
  //多语言配置，参数 zhCN、enUS，默认zhCN
  languageEnv: localStorage.getItem('languageEnv') || LANGUAGES_ENV,
  //是否需要登录验证，不开启将不需要登录，或者随意输入登录信息也阔以登录
  isLogin: false,
  isB2BLogin: false,
  //是否开启组织机构机制
  isMultiOrg: true,
  //组织机构是直接显示value，还是显示欢迎语
  sysType: 'entCenter',
  //是否显示消息
  isMsgNotify: true,
  //密码是否md5处理
  isMd5Password: true,
  homePath: '/',
  appKey: '81c09e3069a2d443fe5fd0243ce023db',
  // 统一配置Cookie，所有的Cookie的键名均放在这个节点下,清空Cookie的方法会统一清楚这里的Cookie,如果有需要清楚的则需要在这里配置
  cookie: {
    // auth_name: 'boc_auth',
    user_name: 'user_name',
    boc_auth: 'boc_auth',
    boc_auth_name: 'boc_auth_name',
    user_id: 'user_id',
    appKey: '81c09e3069a2d443fe5fd0243ce023db',
    childIframeId: 'childIframeId',
    noHeader: 'noHeader',
    loginUrl: 'loginUrl',
    instance_id: 'instance_id',
    tenant_id: 'tenant_id',
    ChildSystemLink: 'ChildSystemLink',
    key: 'key',
    childSystemApplicationKey: 'childSystemApplicationKey',
    childSystemLink: 'childSystemLink',
    childrenInstanceId: 'childrenInstanceId'
  },
  //路由缓存配置
  routerCache: {
    isStart: false,//是否启用,如果为false则不启用所有缓存
    //需要排除的路由， 其包含的路由将不会参与到缓存中 , 路由名第一个字母不能是 '/'
    ruleOutCacheRouter: ['ruleConfig', 'bundle-authority-mgmt/RuleTemplateConfig', 'bundle-appResource-mgmt/ConfigResource', 'bundle-appResource-mgmt/BrowseMenu', 'bundle-appResource-mgmt/TemplateDetail', 'bundle-org-mgmt/OrgDetail', 'jobSampleManage', 'manuallyDetail', 'messageDetail', 'spaceDetail', 'roleAdd', 'applicationResources', 'userAdd', 'bundle-appResource-mgmt/AppMgmt', 'bundle-org-mgmt/EmployeeUserList', 'productList', 'productDetail','userRelate'],
    //缓存队列的长度
    cacheLength: 10,
    //要对比的url参数发生变化即清除缓存的路由
    updateDeCache: true, //如果是数组 则只对比数组包含的路由，如果等于 true  则所有的路由都会对比参数
    isPageTabsDe: false,//是否切换的页签时候删除缓存
  },
  //表单默认宽度分配参数
  formItemLayout: {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 12 }
    }
  },
  // 环境变量
  ENV: ENV || 'loc',
  // 静态资源CDN前缀
  CDN_BASE: pathname.substr(0, pathname.length - 1),
  // 后端接口基础地址
  BACKEND_BASE: BACKEND_BASE,
  // 前端静态资源发布路径
  publicPath: pathname.substr(0, pathname.length - 1),
  // 上传组件的默认显示图片
  uploadImgdefault: CDN_BASE + '/assets/imgs/upload_default.png',
  // 用户账户密码规则, 只支持正则
  PASSWORD_RULE: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}$/,
  // 用户密码输入框显示
  PASSWORD_RULE_PLACEHOLDER: null,
  PHONE_RULE: /^1[3456789]\d{9}$/,
};

// 根据不同环境变量，不同的配置
let envConfig = {
  //本地环境
  loc: {
    mock: false,
    publicPath: '',
    BACKEND_BASE: 'http://ide-test.yx.com/test',
    hostName: `http://ide-test.yx.com/test/boc-operation-web-pc/`,
    appName: 'appName.loc',
    // 应用组转跳转的编辑地址
    XeditorPathForEdit: 'http://xeditor.dtyunxi.cn/#/PageEdit?lcdpEnv=mpc-dev',
    XeditorPathForAdd: 'http://xeditor.dtyunxi.cn/#/PageAdd?lcdpEnv=mpc-dev',
  },
  //开发环境
  dev: {
    mock: false,
    BACKEND_BASE: 'http://ide-dev.yx.com/dev',
    appName: 'appName.dev',
    // 应用组转跳转的编辑地址
    XeditorPathForEdit: 'http://xeditor.dtyunxi.cn/#/PageEdit?lcdpEnv=mpc-dev',
    XeditorPathForAdd: 'http://xeditor.dtyunxi.cn/#/PageAdd?lcdpEnv=mpc-dev',
  },
  uat: {
    BACKEND_BASE: 'https://uat-tp-api.tsbeer.com',
    appName: 'appName.uat',
    // 应用组转跳转的编辑地址
    XeditorPathForEdit: 'http://xeditor.dtyunxi.cn/#/PageEdit?lcdpEnv=mpc-uat',
    XeditorPathForAdd: 'http://xeditor.dtyunxi.cn/#/PageAdd?lcdpEnv=mpc-uat',
  },
  //测试环境
  test: {
    mock: false,
    BACKEND_BASE: 'http://192.168.33.13:8900',
    appName: 'appName.test',
    // 应用组转跳转的编辑地址
    XeditorPathForEdit: 'http://xeditor.dtyunxi.cn/#/PageEdit?lcdpEnv=mpc-test',
    XeditorPathForAdd: 'http://xeditor.dtyunxi.cn/#/PageAdd?lcdpEnv=mpc-test',
  },
  //集成环境
  stage: {
    mock: false,
    BACKEND_BASE: `${window.document.location.origin}/i-dc-p/gateway`,
    appName: 'appName.stage',
    // 应用组转跳转的编辑地址
    XeditorPathForEdit: 'http://xeditor.dtyunxi.cn/#/PageEdit?lcdpEnv=mpc-stage',
    XeditorPathForAdd: 'http://xeditor.dtyunxi.cn/#/PageAdd?lcdpEnv=mpc-stage',
  },
  //演示环境
  demo: {
    mock: false,
    BACKEND_BASE: `${window.document.location.origin}/i-dc-p/gateway`,
    appName: 'appName.demo',
    // 应用组转跳转的编辑地址
    XeditorPathForEdit: 'http://xeditor.dtyunxi.cn/#/PageEdit?lcdpEnv=mpc-prod',
    XeditorPathForAdd: 'http://xeditor.dtyunxi.cn/#/PageAdd?lcdpEnv=mpc-prod',
  },
};
const privateConfig = window.privateConfig || {}
const reconvert = (str) => {
  str = str.replace(/(\\u)(\w{1,4})/gi, function ($0) {
    return (String.fromCharCode(parseInt((escape($0).replace(/(%5Cu)(\w{1,4})/g, "$2")), 16)));
  });
  str = str.replace(/(&#x)(\w{1,4});/gi, function ($0) {
    return String.fromCharCode(parseInt(escape($0).replace(/(%26%23x)(\w{1,4})(%3B)/g, "$2"), 16));
  });
  str = str.replace(/(&#)(\d{1,6});/gi, function ($0) {
    return String.fromCharCode(parseInt(escape($0).replace(/(%26%23)(\d{1,6})(%3B)/g, "$2")));
  });

  return str;
}

const getRootPath = () => {
  var curPath = window.document.location.href;
  var pathName = window.document.location.pathname;
  var pos = curPath.indexOf(pathName);
  //获取主机地址，如： http://localhost:8083
  var locPath = curPath.substring(0, pos);
  return locPath;
};

// 当设置mock为false时，有可能菜单和路由信息接口从本地获取
const localMenuAndRoute = url => {
  let arr = ['menu/list', 'router/list'];
  // let arr = [];
  if (-1 !== arr.indexOf(url)) {
    return true;
  }
  return false;
};

/**
 * 获得api接口地址
 * @param  {String} url    接口地址
 * @param  {Object} config 基础配置信息
 * @return {String}        转换过的接口地址
 */
const getApiAppName = function ({ url, version, app }) {
  if (!url) {
    return;
  } else if (url.indexOf('http') == 0) {
    return url;
  }

  let str = '';
  // 本机开发环境，则当前assets/mock下面的json
  if (config.mock || localMenuAndRoute(url)) {
    console.log(config.publicPath, '..');
    return getRootPath() + config.publicPath + '/assets/mock/' + url.replace(/\//g, '-') + '.json';
    // 其它环境，则读取真实应用的接口
  } else {
    let host = config.BACKEND_BASE;
    let res
    if (app && version) {
      res = `${host}/api/${app}/${version}/${url}`;
    } else {
      res = `${host}/${url}`;
    }

    return res;
  }
};

forEach(privateConfig, (val, key) => {
  if (isString(val)) {
    privateConfig[key] = reconvert(val)
  }
})
// 合并配置
let config = Object.assign(baseConfig, envConfig[baseConfig.ENV], privateConfig);
config.uploadType = config.uploadType || 'oss';
config.themes = config.themes || 'blue';
config.policyApi = config.policyApi || getApiAppName({url: 'api/basicdata/v1/file/upload/policy'})
privateConfig.routerCacheiIStart !== undefined && (config.routerCache.isStart = privateConfig.routerCacheiIStart)
privateConfig.routerCacheLength !== undefined && (config.routerCache.cacheLength = privateConfig.routerCacheLength)
// 拼接接口所需域名和服务名，只需要输入接口名即可  如 yundt/mgmt/item/list-by-page，也不要加斜杆开始，
// 如果接口以http开头，则不会进拼接，而是保留原样
// 如果是mock，则会去assets/mock请求同名json，但/会被替换为-   如  yundt-mgmt-item-list-by-page.js
config.apiAppName = getApiAppName;

export default config;



// WEBPACK FOOTER //
// ./src/config/Config.js